import { z } from "zod/v4";

import { OfferDtoSchema, PatchOfferDtoSchema } from "../../../dtos/offers";

export const PatchOfferRequestBodySchema = z.object({
  offer: PatchOfferDtoSchema,
});

export type PatchOfferRequestBodyType = z.infer<
  typeof PatchOfferRequestBodySchema
>;

export const PatchOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type PatchOfferResponseBodyType = z.infer<
  typeof PatchOfferResponseBodySchema
>;

export const PatchOfferRequestPathParamSchema = z.object({
  variationId: z.uuid(),
  offerId: z.uuid(),
});

export type PatchOfferRequestPathParamType = z.infer<
  typeof PatchOfferRequestPathParamSchema
>;
